import { render, staticRenderFns } from "./PortalPage.vue?vue&type=template&id=58046319&"
import script from "./PortalPage.vue?vue&type=script&lang=js&"
export * from "./PortalPage.vue?vue&type=script&lang=js&"
import style0 from "./PortalPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports